function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { Close, Photo } from '@suranceadmin/icons/native';
import React from 'react';
import { Image, StyleSheet, View } from 'react-native';
import LinkButton from '../Button/LinkButton';
import { withTheme } from '../../core/theming';

const ImagePicker = _ref => {
  let {
    theme: {
      colors
    },
    deviceImage,
    deviceIcon,
    onAddImage,
    onRemoveImage,
    addPhotoTitle,
    imageAccessibility,
    buttonAccessibility,
    style
  } = _ref;
  return /*#__PURE__*/React.createElement(View, {
    style: style
  }, deviceImage ? /*#__PURE__*/React.createElement(View, {
    style: styles.deviceImageView
  }, /*#__PURE__*/React.createElement(Image, _extends({}, imageAccessibility, {
    style: styles.deviceImage,
    source: {
      uri: deviceImage
    }
  })), /*#__PURE__*/React.createElement(LinkButton, _extends({}, buttonAccessibility, {
    style: styles.deviceImageButton,
    onPress: onRemoveImage,
    icon: /*#__PURE__*/React.createElement(Close, {
      width: 16,
      height: 16,
      color: colors.icon.link
    })
  }))) : /*#__PURE__*/React.createElement(View, {
    style: styles.deviceIconView
  }, deviceIcon && /*#__PURE__*/React.cloneElement(deviceIcon, { ...imageAccessibility
  }), /*#__PURE__*/React.createElement(LinkButton, _extends({}, buttonAccessibility, {
    style: styles.deviceIconButton,
    onPress: onAddImage,
    title: addPhotoTitle,
    icon: /*#__PURE__*/React.createElement(Photo, {
      width: 16,
      height: 16,
      color: colors.icon.link,
      style: {
        marginRight: 8
      }
    })
  }))));
};

const styles = StyleSheet.create({
  deviceImageView: {
    width: 120,
    height: 120,
    alignSelf: 'center',
    justifyContent: 'center'
  },
  deviceImage: {
    width: 104,
    height: 104,
    borderRadius: 52,
    resizeMode: 'cover',
    alignSelf: 'center'
  },
  deviceImageButton: {
    position: 'absolute',
    right: -20,
    top: -20
  },
  deviceIconView: {
    height: 120,
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center'
  },
  deviceIconButton: {
    position: 'absolute',
    right: 0,
    top: -20
  }
});
export default withTheme(ImagePicker);
//# sourceMappingURL=index.js.map